import { User } from '@/payload-types';
import { getUrl } from '@/utilities/domainHelper';

export const rest = async (
  url: string,
  args?: any,
  options?: RequestInit,
): Promise<null | undefined | User> => {
  const method = options?.method || 'POST';

  try {
    const res = await fetch(getUrl() + url, {
      method,
      ...(method === 'POST' ? { body: JSON.stringify(args) } : {}),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      ...options,
    });

    const { errors, user } = (await res.json()) as {
      errors: { message: string }[];
      user: User;
    };

    if (errors) {
      throw new Error(errors[0].message);
    }

    if (res.ok) {
      return user;
    }
  } catch (e: unknown) {
    throw new Error(e as string);
  }
};
